export default ({terms,selectedTerms,setSelectedTerms}) => {
    const {useState} = React;
    const [mobileOpen,setMobileOpen] = useState(false);

    const toggleFilter = (term) => {
        if(selectedTerms.includes(term)){
            setSelectedTerms(selectedTerms.filter(x=>x!=term));
        }else {
            setSelectedTerms([...selectedTerms, term]);
        }
        setMobileOpen(false)
    }

    return (
        <div className="activities-filters">
            <span onClick={()=>setMobileOpen(!mobileOpen)} >{ wp.i18n.__('Filters','theme-client') } <i class="fa-regular fa-filter"></i></span>

            <div className={"filters-wrapper" + (mobileOpen?' open':'')}>
                <span className={selectedTerms.length == 0?"active":""} onClick={()=>{setSelectedTerms([]);setMobileOpen(false);}} >{wp.i18n.__('See all','theme-client')}</span> 
                {terms.map( term => (
                    <span className={selectedTerms.includes(term.id)?'active':''} onClick={()=>{toggleFilter(term.id);}} >{term.name}</span>
                ))}
            </div>
        </div>
    )
}